import script from "./LanguageToggle.vue?vue&type=script&setup=true&lang=js"
export * from "./LanguageToggle.vue?vue&type=script&setup=true&lang=js"

import "./LanguageToggle.vue?vue&type=style&index=0&id=16e23545&scoped=true&lang=scss"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16e23545"]])

export default __exports__